import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {CloseableWindow} from "../../pro-report/shared/closeable-window";
import {NotificationWindow, NotificationWindowDetails} from "../../pro-report/shared/notification-window";
import {Notification_Window_TOKEN} from "../../pro-report/shared/injection-token";

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements CloseableWindow, NotificationWindow {

  public details: NotificationWindowDetails = new NotificationWindowDetails();

  @Output()
  public closePanel = new EventEmitter<boolean>();

  constructor(@Inject(Notification_Window_TOKEN) details: NotificationWindowDetails) {
    if (details) {
      this.details = details;
    }
  }

  submit(val: boolean): void {
    this.closePanel.emit(val);
  }

}
